import {
  Dashboard as DashboardIcon,
  ViewKanban as TasksIcon,
  MenuBook as BooksIcon,
  StickyNote2 as NotesIcon,
  DynamicFeed as ScrollIcon,
} from '@mui/icons-material';
import type { SvgIconComponent } from '@mui/icons-material';

export interface AppNavItem {
  label: string;
  path: string;
  icon: SvgIconComponent;
  matches?: (pathname: string) => boolean;
}

export const appNavItems: AppNavItem[] = [
  {
    label: 'Dashboard',
    path: '/',
    icon: DashboardIcon,
    matches: (pathname) => pathname === '/',
  },
  {
    label: 'Tasks',
    path: '/tasks',
    icon: TasksIcon,
    matches: (pathname) => pathname === '/tasks' || pathname.startsWith('/tasks/'),
  },
  {
    label: 'Books',
    path: '/books',
    icon: BooksIcon,
    matches: (pathname) => pathname === '/books' || pathname.startsWith('/books/'),
  },
  {
    label: 'Notes',
    path: '/notes',
    icon: NotesIcon,
    matches: (pathname) => pathname === '/notes' || pathname.startsWith('/notes/'),
  },
  {
    label: 'Scroll',
    path: '/scroll',
    icon: ScrollIcon,
    matches: (pathname) => pathname === '/scroll' || pathname.startsWith('/scroll/'),
  },
];

export const getActiveNavItem = (pathname: string): AppNavItem =>
  appNavItems.find((item) => item.matches?.(pathname) ?? pathname === item.path) ??
  appNavItems[0];
